// extracted by mini-css-extract-plugin
export default {"container":"highlight-card_container__--Etn"};